export default "__VITE_ASSET__C1DJ5f0d__"